// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"93f03fe5","597":"ed41d5ce","885":"4cea13cd"}[chunkId] + ".chunk.js";
};